"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Matcher = require("matcher");
function matchPath(value, options) {
    if (options.matches) {
        const patterns = (value || '').split(',').filter(Boolean);
        return item => {
            const p = typeof item.path === 'string' ? item.path : '';
            return patterns.some(pattern => Matcher.isMatch(p, pattern));
        };
    }
    return item => item.path === value;
}
exports.matchPath = matchPath;
//# sourceMappingURL=match-path.js.map